import React from "react";
import { useRef, useContext } from "react";
import { SleepLogHttpServiceContext } from "../../components/shared/sleep-log-http-service.provider";
import SleepLogSettingsService from "./SleepLogSettingsService";

export const SleepLogSettingsServiceContext = React.createContext<SleepLogSettingsService | undefined>(undefined);

export const useSleepLogSettingsServiceProvider = () => {
    const serviceRef = useRef<SleepLogSettingsService | undefined>(undefined);
    const sleepLogHttpService = useContext(SleepLogHttpServiceContext)!;

    if (serviceRef.current === undefined) {
        serviceRef.current = new SleepLogSettingsService(sleepLogHttpService);
    }

    const service = serviceRef.current;
    return service;
}

export function SleepLogSettingsServiceProvider(props: any) {
    const service = useSleepLogSettingsServiceProvider();

    return (
        <SleepLogSettingsServiceContext.Provider value={service}>
            {props.children}
        </SleepLogSettingsServiceContext.Provider>
    );
}